module.exports = __webpack_public_path__ + "img/ibm.816b8bb5.png";